import React from 'react'
import { Col } from 'reactstrap'
import Chip from '@mui/material/Chip'

function CategoryFilter({
  categories,
  selected,
  onChange,
  ownFilter,
  openOwnFilterDialog,
}) {
  const handleCategoryChange = (value) => {
    if (selected !== value && onChange) {
      onChange(value)
    }
  }

  if (categories === undefined) {
    return null
  }

  const baseStyle = { marginRight: 4, marginBottom: 4, marginTop: 4, color: '#000', fontWeight: 'bold', textTransform: 'uppercase' }
  const inactiveStyle = { ...baseStyle, backgroundColor: '#fff' }
  const chips = []

  if (categories && categories.length > 0) {
    const sortedCategories = categories
      .sort((a, b) => a.order - b.order)
      .filter((c) => c.enabled)
    sortedCategories.forEach((e) => {
      const _cat = e.category.toLowerCase()
      const isActive = selected === _cat && !ownFilter
      chips.push(
        <Chip
          key={_cat}
          label={e.category}
          size='small'
          clickable
          color='primary'
          variant={isActive ? 'default' : 'outlined'}
          onClick={() => handleCategoryChange(_cat)}
          style={isActive ? baseStyle : inactiveStyle}
        />
      )
    })
  }

  const allActive = (!selected || selected === 'all') && !ownFilter
  chips.push(
    <Chip
      key='typeall'
      label='Kaikki'
      size='small'
      clickable
      color='primary'
      variant={allActive ? 'default' : 'outlined'}
      onClick={() => handleCategoryChange('all')}
      style={allActive ? baseStyle : inactiveStyle}
    />
  )

  chips.push(
    <Chip
      key='ownfilter'
      label={ownFilter ? ownFilter.name : 'Omat'}
      size='small'
      clickable
      color='primary'
      variant={ownFilter ? 'default' : 'outlined'}
      onClick={() => openOwnFilterDialog()}
      style={ownFilter ? baseStyle : inactiveStyle}
    />
  )

  return (
    <Col md='6' className='mt-2'>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>{chips}</div>
    </Col>
  )
}

export default CategoryFilter
